import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import type ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import type SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export const getItems = async (
    ids: string[],
    itemShape: ItemResponseShape,
    shapeName?: string,
    internetMessageId?: string
): Promise<SingleResponseMessage[]> => {
    const serviceItemIds = ids.map(id => itemId({ Id: id }));
    const response = await getItemOperation({
        Header: getJsonRequestHeader(),
        Body: getItemRequest({
            ItemShape: itemShape,
            ItemIds: serviceItemIds,
            ...(shapeName && { ShapeName: shapeName }),
            ...(internetMessageId && { InternetMessageId: internetMessageId }),
        }),
    });
    return response?.Body?.ResponseMessages?.Items;
};
